var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"supervisor-intro-view",class:{'clear-header':_vm.isWechatBrowser}},[(!_vm.isWechatBrowser)?_c('my-header',{attrs:{"title":"独立设计师","showBack":true}}):_vm._e(),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-part"},[_c('img',{staticClass:"intro-img",attrs:{"src":require("../../assets/designer_intro.png")}})])
}]

export { render, staticRenderFns }